var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeplusNoLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 83.7",
    style: {
      enableBackground: "new 0 0 425.2 83.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E60014;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "39.8,26.1 15.3,26.1 15.3,2.1 0,2.1 0,65.4 15.3,65.4 15.3,38.9 39.8,38.9 39.8,65.4 55.1,65.4  55.1,2.1 39.8,2.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    className: "st0",
    width: 14.8,
    height: 65.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.1,19.3c-13.7,0-24.8,9-24.8,23.8c0,14.4,11.1,23.8,24.8,23.8c13.7,0,24.8-9,24.8-23.8 C112.8,28.3,101.7,19.3,88.1,19.3z M88.1,54.4c-5.8,0-10.5-5.1-10.5-11.4s4.7-11.4,10.5-11.4c5.8,0,10.5,5.1,10.5,11.4 S93.8,54.4,88.1,54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.5,19.6c-5.7,0-10.4,3.1-13.4,7.6c-2.2-4.6-6.4-7.6-14.3-7.6c-4.4,0-8.8,2.6-12,6.6 c-0.2,0.2-0.3,0.5-0.5,0.7c0,0,0,0,0,0v-6.1h-14.3v44.6h14.8V52.1V40.4c0-4.9,3.4-8.8,6.8-8.8c5.6,0,6.8,3.9,6.8,8.8v17.8v7.1h14.7 v-12v-13c0-4.9,3.4-8.8,6.9-8.8c5.6,0,6.9,3.9,6.9,8.8v17.7v7.2h14.7v-25h-0.1c0-0.5,0.1-1,0.1-1.5 C191.5,28.3,187.7,19.6,174.5,19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.4,19.3c-12.8,0-23.8,9-23.8,23.8v0c0,0.4,0,0.8,0,1.2c0,0.1,0,0.2,0,0.2c0,0.9,0.1,1.7,0.2,2.6 c1.8,12.1,11.4,19.8,22.9,19.8c0.2,0,0.5,0,0.7,0c0.2,0,0.4,0,0.6,0c8.2,0,15.5-3.3,19.9-9.2l-1.7-1.1l-8.6-5.6 c-1.9,2.6-5.5,4.4-9.7,4.4c-3.1,0-10.3-2.4-10.3-8.1H234h1.2h10.6c0-0.1,0-0.1,0-0.1c0.2-1.3,0.3-2.6,0.3-4v0 C246,28.3,236.2,19.3,223.4,19.3z M213.7,38c1.3-6.5,5.6-8.4,10-8.4c6.6,0,8.3,4,8.8,8.4H213.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.4,19.3c-5.4,0-10.4,2-14.1,5.8c-0.3,0.3-0.5,0.5-0.7,0.8v-5.1h-14v63h14.8V61c3.7,3.8,8.6,5.9,14.1,5.9 c11.4,0,20.7-9,20.7-23.8C304.1,28.3,294.8,19.3,283.4,19.3z M279.3,54.4c-4.6,0-8.6-3.3-9.9-7.8c-0.3-1.1-0.5-2.3-0.5-3.6 c0-1.2,0.2-2.5,0.5-3.6c1.4-4.6,5.3-7.8,9.9-7.8c5.8,0,10.5,5.1,10.5,11.4S285.1,54.4,279.3,54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.5,47c0,3.5-1.8,8.2-7.2,8.2c-5.4,0-7.2-4.7-7.2-8.2V20.7h-14.8v27.6c0,9.1,7.4,18.3,22,18.3 c14.6,0,22-9.2,22-18.3V20.7h-14.8V47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M407.8,37.2c-3.2-0.6-5.5-1.7-5.5-3.7c0-2.1,1.6-3.4,5.5-3.4c5.5,0,9.3,3.8,9.3,3.8l8-8c0,0-5.2-6.5-17.8-6.5 c-14.6,0-18.6,8.8-18.6,14.6c0,12.3,12.9,13.2,15.7,14c3.2,0.6,6,2.3,6,4.3c0,2.1-1.3,3.8-5.2,3.8c-5.5,0-10.9-5.1-10.9-5.1 l-8.3,8.8c0,0,7.1,7,19.7,7c14.6,0,18.8-8.8,18.8-14.6C424.6,39.2,410.6,38,407.8,37.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeplusNoLine);
export default __webpack_public_path__ + "static/media/homeplus_no_line.b07f699fcc6b0bff1fa49660ef4da69c.svg";
export { ForwardRef as ReactComponent };